import * as ko from "knockout";
import { searchCriteria } from "./_searchCriteria";

export class ComplaintReqSearchCriteria extends searchCriteria {
  page_dir: KnockoutObservable<string>;
  created_dttm_last_value: KnockoutObservable<Date>;
  sort_field_last_value: KnockoutObservable<string>;
  complaint_id: KnockoutObservable<string>;
  original_delivery_order: KnockoutObservable<string>;
  created_dttm_from: KnockoutObservable<Date>;
  created_dttm_to: KnockoutObservable<Date>;
  complaint_type: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  complaint_status: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;

  constructor(item) {
    super(item);
    this.complaint_id = ko.observable(item.complaint_id);
    this.original_delivery_order = ko.observable(item.original_delivery_order);
    this.complaint_type = ko.observable(item.complaint_type);
    this.status = ko.observable(item.status);
    this.complaint_status = ko.observable(item.complaint_status);
    this.created_dttm_from = ko.observable(this.formatJSONDate(item.created_dttm_from));
    this.created_dttm_to = ko.observable(this.formatJSONDate(item.created_dttm_to));
    this.page_dir = ko.observable(item.page_dir);
    this.sort_field_last_value = ko.observable(item.sort_field_last_value);
    this.created_dttm_last_value = ko.observable(item.created_dttm_last_value);
    this.created_by = ko.observable(item.created_by);
  }
}
